export default {
  "Sivut": "Sivut",
  "Ei luokiteltu": "Ei luokiteltu",
  "Viimeiset 8 viikkoa": "Viimeiset 8 viikkoa",
  "Vie palautteet": "Vie palautteet",
  "Ulkoasuasetukset": "Ulkoasuasetukset",
  "Logo": "Logo",
  "Väri": "Väri",
  "Logon tulee olla PNG-tiedosto, jonka tausta on läpinäkyvä.": "Logon tulee olla PNG-tiedosto, jonka tausta on läpinäkyvä.",
  "Ei logoa": "Ei logoa",
  "Valitse logo": "Valitse logo",
  "Logon tulee olla PNG-tiedosto.": "Logon tulee olla PNG-tiedosto.",
  "Tiedosto on liian suuri (max 5 MB).": "Tiedosto on liian suuri (max 5 MB).",
  "Logon tausta tulee olla läpinäkyvä.": "Logon tausta tulee olla läpinäkyvä.",
  "Tiedostoa ei voitu lukea kuvana.": "Tiedostoa ei voitu lukea kuvana.",
  "Logon tallennus epäonnistui.": "Logon tallennus epäonnistui.",
  "Poista logo": "Poista logo",
  "Logon poistaminen epäonnistui.": "Logon poistaminen epäonnistui.",
  "Näytön logo korvaa yrityksen logon tällä näytöllä. Kuvan ei tarvitse olla neliö.": "Näytön logo korvaa yrityksen logon tällä näytöllä. Kuvan ei tarvitse olla neliö.",
  "Tehosteväriä käytetään sovelluksen painikkeissa, otsikoissa ja korostuksissa.": "Tehosteväriä käytetään sovelluksen painikkeissa, otsikoissa ja korostuksissa.",
  "Esikatselu": "Esikatselu",
  "Esimerkki": "Esimerkki",
  "Painike": "Painike",
  "Värin tallennus epäonnistui.": "Värin tallennus epäonnistui.",
  "Pääkäyttäjät": "Pääkäyttäjät",
  "Vain pääkäyttäjät voivat lisätä tai poistaa toisia pääkäyttäjiä.": "Vain pääkäyttäjät voivat lisätä tai poistaa toisia pääkäyttäjiä.",
  "Näytä loki": "Näytä loki",
  "Lisää pääkäyttäjä": "Lisää pääkäyttäjä",
  "Ei pääkäyttäjiä": "Ei pääkäyttäjiä",
  "Et voi poistaa itseäsi pääkäyttäjistä": "Et voi poistaa itseäsi pääkäyttäjistä",
  "Viimeistä pääkäyttäjää ei voi poistaa": "Viimeistä pääkäyttäjää ei voi poistaa",
  "Poista pääkäyttäjistä": "Poista pääkäyttäjistä",
  "confirm_remove_mainuser": "Haluatko varmasti poistaa käyttäjän {name} pääkäyttäjistä? Käyttäjä säilyy järjestelmässä tavallisena käyttäjänä.",
  "Hae käyttäjää": "Hae käyttäjää",
  "Kirjoita nimi tai sähköposti": "Kirjoita nimi tai sähköposti",
  "Ei tuloksia": "Ei tuloksia",
  "Lisää pääkäyttäjäksi": "Lisää pääkäyttäjäksi",
  "Pääkäyttäjän lisääminen epäonnistui": "Pääkäyttäjän lisääminen epäonnistui",
  "Pääkäyttäjien muutosloki": "Pääkäyttäjien muutosloki",
  "Ei merkintöjä": "Ei merkintöjä",
  "Toiminto": "Toiminto",
  "Suoritti": "Suoritti",
  "Pääkäyttäjän oikeudet lisätty": "Pääkäyttäjän oikeudet lisätty",
  "Pääkäyttäjän oikeudet poistettu": "Pääkäyttäjän oikeudet poistettu",

  "feedback_newview_info": "Uudistamme palautteiden hallintaa! Kokeile uutta näkymää alta. Uudesta näkymästä tulee oletusnäkymä tulevaisuudessa.",
  "Uusi näkymä": "Uusi näkymä",
  "Ohjeet": "Ohjeet",
  "Puhelinnumero": "Puhelinnumero",
  "Pitkä vastaus": "Pitkä vastaus",
  "Lyhyt vastaus": "Lyhyt vastaus",
  "Valitse yksi": "Valitse yksi",
  "Takaisin": "Takaisin",
  "Saapuneet / luokka": "Saapuneet / luokka",
  "Vanha näkymä": "Vanha näkymä",
  "Päivitä": "Päivitä",
  "Näytä valmiit": "Näytä valmiit",
  "Tieto ei näy palautteen lähettäjälle": "Tieto ei näy palautteen lähettäjälle",
  "Sisäinen otsikko": "Sisäinen otsikko",
  "Ei valmiita palautteita": "Ei valmiita palautteita",
  "Ei saapuneita palautteita": "Ei saapuneita palautteita",
  "Ei käsittelyssä olevia palautteita": "Ei käsittelyssä olevia palautteita",
  "Näytä infotv näytöillä": "Näytä infotv-näytöillä",
  "Ei käytössä": "Ei käytössä",
  "Lomake": "Lomake",
  "Käytä mukautettua lomaketta": "Käytä mukautettua lomaketta",
  "Poista palautetyyppi käytöstä ja tallenna muutokset muokataksesi lomakekenttiä": "Poista palautetyyppi käytöstä ja tallenna muutokset muokataksesi lomakekenttiä",
  "Sisältö": "Sisältö",
  "Asetukset": "Asetukset",
  "Lataa ja lisää": "Lataa ja lisää",
  "Näyttö": "Näyttö",
  "Toissijainen sisältö (30%)": "Toissijainen sisältö (30%)",
  "Pääsisältö (70%)": "Pääsisältö (70%)",
  "Alatunnisteen tekstit": "Alatunnisteen tekstit",
  "Lisää teksti": "Lisää teksti",
  "Näytöt": "Näytöt",
  "Ulkoasu": "Ulkoasu",
  "Sää": "Sää",
  "Näytön sisällönhallinta": "Näytön sisällönhallinta",
  "Asettelu": "Asettelu",
  "Haluatko varmasti poistaa sisällön näytöltä?": "Haluatko varmasti poistaa sisällön näytöltä?",
  "Jaettu asettelu (70% / 30%)": "Jaettu asettelu (70% / 30%)",
  "Koko leveys": "Koko leveys",
  "Tumma tila": "Tumma tila",
  "Näytä alatunniste": "Näytä alatunniste",
  "Sisällön näyttöaika (sekuntia)": "Sisällön näyttöaika (sekuntia)",
  "Valitse kirjastosta": "Valitse kirjastosta",
  "Ei hakutuloksia": "Ei hakutuloksia",
  "Ei kuvia kirjastossa": "Ei kuvia kirjastossa",
  "Lisää näytölle": "Lisää näytölle",
  "Virhe lisättäessä sisältöä": "Virhe lisättäessä sisältöä",
  "kohdetta": "kohdetta",
  "Lisää": "Lisää",
  "Lataa kuva": "Lataa kuva",
  "Kirjastosta": "Kirjastosta",
  "Uutiset": "Uutiset",
  "Tapahtumat": "Tapahtumat",
  "Lisää sisältöä yllä olevilla painikkeilla": "Lisää sisältöä yllä olevilla painikkeilla",
  "aktiivista uutista.": "aktiivista uutista.",
  "Näytetään max 5 uusinta uutista": "Näytetään max 5 uusinta uutista",
  "Ei aktiivisia uutisia": "Ei aktiivisia uutisia",
  "Ilmoittautuneet": "Ilmoittautuneet",
  "permanent_pages_info": "Pysyvät sivut näkyvät Piiri-sovelluksen valikossa omina osioinaan (erimerkiksi otsikolla Meidän yritys). Voit luoda uusia osioita, jos haluat ryhmitellä pysyvien sivujen sisältöjä erillisiin valikossa näkyviin aiheisiin. Uusi osio tulee näkyviin valikkoon, kun sovellus käynnistetään uudelleen tai selaimen sivu päivitetään",
  "Osio": "Osio",
  "Luo uusi osio": "Luo uusi osio",
  "Pysyvät sivut": "Pysyvät sivut",
  "Uusi kyselytyökalu": "Uusi kyselytyökalu",
  "Lomakkeella on vastauksia. Muokkaus rajoitettu.": "Lomakkeella on vastauksia. Muokkaus rajoitettu.",
  "Huom: Lomaketta voi muokata rajoitetusti sen jälkeen kun siihen on tullut vastauksia.": "Huom: Lomaketta voi muokata rajoitetusti sen jälkeen kun siihen on tullut vastauksia.",
  "surveyinfo1": "Uudistamme kyselyjä. Pääset kokeilemaan uutta kyselytyökalua",
  "surveyinfo2": "Piirin mobiilisovellus tulee päivittää uuteen versioon (1.15.0.), jotta uudessa kyselytyökalussa tehdyt kyselyt tulevat käyttäjille näkyviin.",
  "Sinulla ei ole oikeuksia kaikkiin tämän julkaisun ryhmiin.": "Sinulla ei ole oikeuksia kaikkiin tämän julkaisun ryhmiin.",
  "Voit tarkastella julkaisua, mutta et voi tehdä muutoksia.": "Voit tarkastella julkaisua, mutta et voi tehdä muutoksia.",
  "Oletus": "Oletus",
  "Vie kaaviot kuvana": "Vie kaaviot kuvana",
  "Suodattimet": "Suodattimet",
  "Tyhjennä": "Tyhjennä",
  "Aikavyöhyke": "Aikavyöhyke",
  "Vastausvaihtoehto": "Vastausvaihtoehto",
  "Lisää vaihtoehto": "Lisää vaihtoehto",
  "Tyhjä vaihtoehto": "Tyhjä vaihtoehto",
  "Vaihtoehto": "Vaihtoehto",
  "Vastausvaihtoehdot": "Vastausvaihtoehdot",
  "Haluatko varmasti poistaa vastausvaihtoehdon?": "Haluatko varmasti poistaa vastausvaihtoehdon?",
  "vastausta": "vastausta",
  "Ei vastauksia": "Ei vastauksia",
  "Kentällä ei ole otsikkoa": "Kentällä ei ole otsikkoa",
  "Klikkaa muokataksesi kenttää": "Klikkaa muokataksesi kenttää",
  "Ohjeteksti (valinnainen)": "Ohjeteksti (valinnainen)",
  "Päivämäärä": "Päivämäärä",
  "Pakollinen": "Pakollinen",
  "Kentän otsikko": "Kentän otsikko",
  "Tietotyyppi": "Tietotyyppi",
  "Vastausaika on pakollinen": "Vastausaika on pakollinen",
  "Monirivinen teksti": "Monirivinen teksti",
  "Ei kysymyksiä. Lisää ensimmäinen kysymys vasemmalta.": "Ei kysymyksiä. Lisää ensimmäinen kysymys vasemmalta.",
  "Monivalinta": "Monivalinta",
  "Valinta": "Valinta",
  "Valitse vähintään yksi ryhmä": "Valitse vähintään yksi ryhmä",
  "Teksti": "Teksti",
  "Lisää kysymys": "Lisää kysymys",
  "Lomakkeen kentät": "Lomakkeen kentät",
  "Julkaise ryhmiin": "Julkaise ryhmiin",
  "Kopioi kysely": "Kopioi kysely",
  "Tietoa Piiri-sovelluksesta": "Tietoa Piiri-sovelluksesta",
  "Ryhmän ylläpitäjä näkee vain ylläpitämiensä ryhmien tiedostot": "Ryhmän ylläpitäjä näkee vain ylläpitämiensä ryhmien tiedostot",
  "Sivu": "Sivu",
  "Lukukuittaus saatu": "Lukukuittaus saatu",
  "Ei lukukuittausta": "Ei lukukuittausta",
  "Raportti": "Raportti",
  "Lukukuittauksia ei ole käytössä": "Lukukuittauksia ei ole käytössä",
  "Versio": "Versio",
  "Jos nostatte versionumeroa, käyttäjiltä vaaditaan sisällölle uudelleen lukukuittaus": "Jos nostatte versionumeroa, käyttäjiltä vaaditaan sisällölle uudelleen lukukuittaus",
  "Selite (valinnainen)": "Selite (valinnainen)",
  "Teksti näytetään käyttäjille kuittauksen yhteydessä": "Teksti näytetään käyttäjille kuittauksen yhteydessä",
  "Vaadi lukukuittaus": "Vaadi lukukuittaus",
  "Muokkaa kansiota": "Muokkaa kansiota",
  "Uusi kansio": "Uusi kansio",
  "Uusi alikansio": "Uusi alikansio",
  "tiedostoa": "tiedostoa",
  "Muokkaa": "Muokkaa",
  "Lukukuittaukset": "Lukukuittaukset",
  "Failed to submit acknowledgment. Please try again.": "Kuittauksen lähettäminen epäonnistui. Yritä uudelleen.",
  "Kuittaa luetuksi": "Kuittaa luetuksi",
  "Lukukuittaus": "Lukukuittaus",
  "Lukukuittaus vaaditaan": "Lukukuittaus vaaditaan",
  "Olet kuitannut tämän luetuksi": "Olet kuitannut tämän luetuksi",
  "Sisältö on päivittynyt viime kuittauksesi jälkeen. Kuittaa uudelleen.": "Sisältö on päivittynyt viime kuittauksesi jälkeen. Kuittaa uudelleen.",
  "Tämä sisältö vaatii lukukuittauksen.": "Tämä sisältö vaatii lukukuittauksen.",
  "Your browser does not support the video tag.": "Selaimesi ei tue videotoisintoa.",
  "Avaa linkki": "Avaa linkki",
  "Kaikki tiedostot": "Kaikki tiedostot",
  "Kansio": "Kansio",
  "Avaa tiedosto": "Avaa tiedosto",
  "Järjestys": "Järjestys",
  "Anna kansion nimi": "Anna kansion nimi",
  "Kansion nimi": "Kansion nimi",
  "Haluatko varmasti poistaa kansion?": "Haluatko varmasti poistaa kansion?",
  "Vie ilmoittautumiset": "Vie ilmoittautumiset",
  "Avainsanoilla voidaan luokitella ja suodattaa uutisia.": "Avainsanoilla voidaan luokitella ja suodattaa uutisia.",
  "Ryhmä on käytössä": "Ryhmä on käytössä",
  "Ryhmä ei ole käytössä": "Ryhmä ei ole käytössä",
  "DisableGroupInfo": "Ryhmä voidaan merkitä ei-aktiiviseksi, jos sillä ei ole yhtään:\n- ylläpitäjää\n- keskustelukanavaa\n- Meidän yritys -sivua (tai muuten nimettyä pysyvää sivua)\n\nNäin merkitset käytössä olleen ryhmän ei-aktiiviseksi:\n- Poista ryhmän ylläpito-oikeudet käyttäjähallinnasta.\n- Merkitse ryhmään liitetyt keskustelukanavat ei-aktiivisiksi.\n- Poista ryhmälle tehdyt Meidän yritys -sivut tai siirrä ne toiselle ryhmälle. Jos pysyvä sivu näkyy useammalle ryhmälle, riittää että poistat sen näkyvyyden poistettavalta ryhmältä.\n\nHuomio!\nRyhmälle luotu muu sisältö (uutiset, tapahtumat, kyselyt, tiedostot) säilyy Piirissä myös silloin, kun ryhmä poistetaan käytöstä.",
  "Käyttäjä halitsee tietoa itse": "Käyttäjä halitsee tietoa itse",
  "Käyttäjän kielivalinta": "Käyttäjän kielivalinta",
  "Tiedoston maksimikoko on 10MB": "Tiedoston maksimikoko on 10MB",
  "Peruuta": "Peruuta",
  "Avainsanat käytössä": "Avainsanat käytössä",
  "Hae": "Hae",
  "Järjestä": "Järjestä",
  "department-info": "Osastojen käyttö on vapaaehtoista. Henkilöstön ryhmittely osastoihin näkyy vain Meillä töissä -osiossa. Jos yritys ryhmittelee henkilöstön osastoihin, käyttäjät voivat etsiä yhteystietoja osastoittain.",
  "Oletusuutiskuva": "Oletusuutiskuva",
  "Julkaisuasetukset": "Julkaisuasetukset",
  "Oletusuutiskuvaa käytetään logon sijaan uutisissa mikäli uutisella ei ole omaa kuvaa.": "Oletusuutiskuvaa käytetään logon sijaan uutisissa mikäli uutisella ei ole omaa kuvaa.",
  "Hae otsikolla": "Hae otsikon mukaan",
  "Kysymys julkaistaan heti": "Kysymys julkaistaan heti",
  "Tapahtuma julkaistaan julkaisuaikana": "Tapahtuma julkaistaan julkaisuaikana",
  "Nimi on pakollinen kaikilla kielillä": "Nimi on pakollinen kaikilla kielillä",
  "Uusi osasto": "Uusi osasto",
  "Kaikki": "Kaikki",
  "Osastot": "Osastot",
  "Uusi ryhmä": "Uusi ryhmä",
  "Ryhmän nimi": "Ryhmän nimi",
  "Oma tila": "Oma tila",
  "Yhteiset liitteet": "Yhteiset liitteet",
  "attachment_lang_tip": "Yhteiset liitteet näkyvät kaikille kielivalinnasta riippumatta. Kieliversioiden liitteet näkyvät vain kyseisen kielivalinnan käyttäjille.",
  "Käännös suoritettu. Varmista käännöksen oikeellisuus ennen tallentamista.": "Käännös suoritettu. Varmista käännöksen oikeellisuus ennen tallentamista.",
  "Suorita käännös": "Suorita käännös",
  "Automaattinen käännös": "Automaattinen käännös",
  "deepl_notice": "Sisällön kääntämiseen käytetään <a href='https://www.deepl.com/en/translator' target='_blank'> DeepL -palvelua</a>. Huomaa, että käännettävä teksti lähetetään DeepLin palvelimille käsiteltäväksi. Yritys on vastuussa käännetyn sisällön oikeellisuuden ja soveltuvuuden varmistamisesta. Työkalu on tarkoitettu vain Piirin sisältöjen kääntämiseen",
  "Haluatko varmasti poistaa käyttäjän? Toimintoa ei voi perua!": "Haluatko varmasti poistaa käyttäjän? Toimintoa ei voi perua!",
  "Jos haluat päivittää kuvan, poista ensin olemassa oleva kuva": "Jos haluat päivittää kuvan, poista ensin olemassa oleva kuva",
  "ryhmää": "ryhmää",
  "Push-ilmoitukset käytössä": "Push-ilmoitukset käytössä",
  "Kansikuvat": "Kansikuvat",
  "Ei kuvia, näytetään logo": "Ei kuvia, näytetään logo",
  "Lisää uusi kansikuva": "Lisää uusi kansikuva",
  "Enintään 5 kuvaa voidaan lisätä": "Enintään 5 kuvaa voidaan lisätä",
  "Haluatko varmasti poistaa kuvan?": "Haluatko varmasti poistaa kuvan?",
  "Kuvien suositeltu kuvasuhde on 16:9, esim. 1920x1080px": "Kuvien suositeltu kuvasuhde on 16:9, esim. 1920x1080px",
  "Kuvat näytetään kuvakarusellissa": "Kuvat näytetään kuvakarusellissa",
  "Vastauksiin liitetään nimi automaattisesti": "Vastauksiin liitetään nimi automaattisesti",
  "Kyselyyn voi vastata useita kertoja": "Kyselyyn voi vastata useita kertoja",
  "Vastaukset kerätään anonyymisti": "Vastaukset kerätään anonyymisti",
  "Tätä asetusta ei voi muuttaa sen jälkeen kun kyselyyn on vastattu": "Tätä asetusta ei voi muuttaa sen jälkeen kun kyselyyn on vastattu",
  "Salli useita vastauksia samalta käyttäjältä": "Salli useita vastauksia samalta käyttäjältä",
  "Palautteiden käsittelijäksi voidaan...": "Huom. Palautteiden käsittelijäksi voidaan valita pääkäyttäjä tai ryhmän ylläpitäjä. Voit lisätä ryhmän ylläpitäjän oikeudet käyttäjän omissa tiedoissa kohdassa Käyttäjät.",
  "Kaikki muutokset kirjataan lokiin": "Kaikki palautteiden käsittelijöihin tehtävät muutokset tallentuvat lokitietoihin. (Katso loki klikkaamalla oikealla olevaa ikonia.)",
  "Valitse käsittelyoikeudet": "Valitse käsittelyoikeudet",
  "Käsittelyoikeudet": "Käsittelyoikeudet",
  "Tallennus onnistui": "Tallennus onnistui",
  "Aikaleima": "Aikaleima",
  "Suorittanut": "Suorittanut",
  "Kohdekäyttäjä": "Kohdekäyttäjä",
  "Tapahtuma": "",
  "Loki": "Loki",
  "CategoryInfo": 'Palautteiden luokittelua ei ole otettu käyttöön. Luo erilaisille palautetyypeille omia kategorioita valitsemalla "Uusi palautetyyppi" ja kirjoittamalla ohjeet palautetyyppiin.',
  "Palautetyypit": "Palautetyypit",
  "Palautetyypin nimi": "Palautetyypin nimi",
  "Valitse palautteen tyyppi": "Valitse palautteen tyyppi",
  "Otsikko on pakollinen kaikilla kielillä": "Otsikko on pakollinen kaikilla kielillä",
  "Ohje palautteen lähettäjälle (esim. mitä tietoja ilmoitukseen tulee lisätä)": "Ohje palautteen lähettäjälle (esim. mitä tietoja ilmoitukseen tulee lisätä)",
  "Lyhyt kuvaus (milloin palautetyyppiä käytetään)": "Lyhyt kuvaus (milloin palautetyyppiä käytetään)",
  "Uusi palautetyyppi": "Uusi palautetyyppi",
  "Palautteiden luokittelu": "Palautteiden luokittelu",
  "Haluatko varmasti ottaa palautteen käsittelyyn?": "Haluatko varmasti ottaa palautteen käsittelyyn?",
  "Käyttäjä on jättänyt yhteystiedot yhteydenottoa varten": "Käyttäjä on jättänyt yhteystiedot yhteydenottoa varten",
  "Palaute on käsitelty": "Palaute on käsitelty",
  "Palauteilmoitukset": "Palautteiden käsittelijät",
  "Kirjoita viesti": "Kirjoita viesti",
  "Sinä": "Sinä",
  "Voit lähettää yhden viestin vastauksena": "Voit lähettää yhden viestin vastauksena",
  "Haluatko varmasti lähettää viestin?": "Haluatko varmasti lähettää viestin?",
  "Palautteet": "Palautteet",
  "Näytä lähetetyt palautteet": "Näytä lähetetyt palautteet",
  "Piilota lähetetyt palautteet": "Piilota lähetetyt palautteet",
  "Haluatko jättää yhteystietosi henkilökohtaista vastausta varten?": "Haluatko jättää yhteystietosi henkilökohtaista vastausta varten?",
  "Käsitelty": "Käsitelty",
  "Avoin": "Avoin",
  "Voit lähettää palautteen lähettäjälle viestin tai vastauksen sen jälkeen, kun palaute on otettu käsittelyyn": "Voit lähettää palautteen lähettäjälle viestin tai vastauksen sen jälkeen, kun palaute on otettu käsittelyyn",
  "Tietoja": "Tietoja",
  "Palautteen lähettäjä voi vastata lähettämääsi viestiin tai viesteihin niin kauan, kunnes palaute on merkitty käsitellyksi.": "Palautteen lähettäjä voi vastata lähettämääsi viestiin tai viesteihin niin kauan, kunnes palaute on merkitty käsitellyksi.",
  "Käyttäjä": "Käyttäjä",
  "Yhteystiedot": "Yhteystiedot",
  "Viestit": "Viestit",
  "Käyttäjä ei ole jättänyt yhteystietoja": "Käyttäjä ei ole jättänyt yhteystietoja",
  "Lähetä lisäkysymys tai vastus": "Lähetä lisäkysymys tai vastus",
  "Vie vastaukset": "Vie vastaukset",
  "Päivitykset": "Päivitykset",
  "Kutsu uudet käyttäjät": "Kutsu uudet käyttäjät",
  "Lisää uusi palautteiden käsittelijä": "Lisää uusi palautteiden käsittelijä",
  "Ilmoitus sähköpostiin": "Ilmoitus sähköpostiin",
  "Push-viesti puhelimeen": "Push-viesti puhelimeen",
  "Kutsu käyttäjiä": "Kutsu käyttäjiä",
  "Käytä viestipohjaa": "Käytä viestipohjaa",
  "Kutsuohje": "Alla oleva viesti lähetetään tekstiviestillä valituille käyttäjille. Halutessasi voit muokata \
  viestiä ennen lähetystä.",
  "Varmista, että käyttäjien puhelinnumerot ovat oikein ennen viestin lähetystä.": "Varmista, että käyttäjien puhelinnumerot ovat oikein ennen viestin lähetystä.",
  "Kutsumattomia käyttäjiä ei löytynyt": "Kutsumattomia käyttäjiä ei löytynyt",
  "Kutsu valitut käyttäjät": "Kutsu valitut käyttäjät",
  "Lähetys käynnissä, odota...": "Lähetys käynnissä, odota...",
  "Lähetys on valmis": "Lähetys on valmis",
  "Kutsu käyttäjälle": "Kutsu käyttäjälle",
  "numeroon": "numeroon",
  "epäonnistui": "epäonnistui",
  "Päivitä lista": "Päivitä lista",
  "Viesti on pakollinen": "Viesti on pakollinen",
  "Kirjoita vastaus": "Kirjoita vastaus",
  "Vastauksia": "Vastauksia",
  "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomutooja ovat ": "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomutooja ovat ",
  "Liitetiedosto": "Liitetiedosto",
  "Halutessasi voi liittää liitetiedoston": "Halutessasi voi liittää liitetiedoston",
  "Halutessasi voit liittää mukaan kuvan tai pdf-tiedoston": "Halutessasi voit liittää mukaan kuvan tai pdf-tiedoston",
  "Liite": "Liite",
  "Ladataan...": "Ladataan...",
  "Vastausaika on päättynyt": "Vastausaika on päättynyt",
  "Ei ilmoittautumisia": "Ei ilmoittautumisia",
  "Voit lähettää viestin Ctrl Enter painikkeilla": "Voit lähettää viestin Ctrl + Enter painikkeilla",
  "Omat keskustelut": "Omat keskustelut",
  "Näytä keskustelukanavat": "Näytä keskustelukanavat",
  "Yksityinen kanava": "Yksityinen kanava",
  "Hallinnoit tätä kanavaa": "Hallinnoit tätä kanavaa",
  "Aloita uusi keskustelu": "Aloita uusi keskustelu",
  "Miten palautteet käsitellään": "Miten palautteet käsitellään",
  "Haku": "Haku",
  "Omat tiedot ja asetukset": "Omat tiedot ja asetukset",
  "Julkaisuaika on pakollinen": "Julkaisuaika on pakollinen",
  "Kuvaus...": "Kuvaus...",
  "Saapunut ...": "Saapunut ...",
  "Nimi puuttuu": "Nimi puuttuu",
  "Haluatko varmasti poistaa tapahtuman?": "Haluatko varmasti poistaa tapahtuman?",
  "Ylläpito": "Ylläpito",
  "Etusivu": "Etusivu",
  "Hallinta": "Hallinta",
  "Muut": "Lisää",
  "Omat tiedot": "Omat tiedot",
  "Kirjaudu ulos": "Kirjaudu ulos",
  "Lähetä": "Lähetä",
  "Olet vastannut kyselyyn": "Olet vastannut kyselyyn",
  "Kyselyt": "Kyselyt",
  "Vastausaika päättyy": "Vastausaika päättyy",
  "Ei kyselyjä": "Ei kyselyjä",
  "Uusi tiedosto lisätty": "Uusi tiedosto lisätty",
  "Yritys": "Yritys",
  "Raahaa kuva tähän tai klikkaa tästä ja valitse kuva tiedostoista.": "Raahaa kuva tähän tai klikkaa tästä ja valitse kuva tiedostoista.",
  "Kuponki": "Kuponki",
  "Otsikko": "Otsikko",
  "Kuvaus": "Kuvaus",
  "Etu julkaistaan heti": "Etu julkaistaan heti",
  "Etu tallennetaan luonnoksena": "Etu tallennetaan luonnoksena",
  "Julkaise": "Julkaise",
  "Tarkista lomakkeen tiedot": "Tarkista lomakkeen tiedot",
  "Poista": "Poista",
  "Tallenna": "Tallenna",
  "Tallenna lisätieto": "Tallenna lisätieto",
  "Henkilöstöedut": "Henkilöstöedut",
  "Uusi etu": "Uusi etu",
  "Julkaistu": "Julkaistu",
  "Keskustelukanavat": "Keskustelukanavat",
  "Nimi": "Nimi",
  "Kuva": "Kuva",
  "Kanavan tyyppi": "Kanavan tyyppi",
  "Yksityinen keskustelu": "Yksityinen keskustelu",
  "Ryhmäkeskustelu": "Ryhmäkeskustelu",
  "Kanavaa hallinnoivat": "Kanavaa hallinnoivat",
  "Käytössä": "Käytössä",
  "Kanava on käytössä": "Kanava on käytössä",
  "Kanava ei ole käytössä": "Kanava ei ole käytössä",
  "Uusi kanava": "Uusi kanava",
  "Aktiivinen": "Aktiivinen",
  "Klo": "Klo",
  "klo": "klo",
  "Ilmoittautuminen päättyy": "Ilmoittautuminen päättyy",
  "Ilmoittautumiset": "Ilmoittautumiset",
  "#": "#",
  "Henkilö": "Henkilö",
  "Ilmoitautumisaika": "Ilmoitautumisaika",
  "Kommentti": "Kommentti",
  "Tapahtumat": "Tapahtumat",
  "Julkaise ryhmään": "Julkaise ryhmään",
  "Tapahtuman alkuaika": "Tapahtuman alkuaika",
  "Tapahtuman päättymisaika": "Tapahtuman päättymisaika",
  "Palauteasetukset": "Palauteasetukset",
  "Ilmoittautuminen": "Ilmoittautuminen",
  "Kommentti ilmoittautumisen yhteydessä": "Kommentti ilmoittautumisen yhteydessä",
  "Tapahtuma julkaistaan heti": "Tapahtuma julkaistaan heti",
  "Tapahtuma tallennetaan luonnoksena": "Tapahtuma tallennetaan luonnoksena",
  "Ryhmä on pakollinen": "Ryhmä on pakollinen",
  "Otsikko ja teksti on pakollinen": "Otsikko ja teksti on pakollinen",
  "Alkuaika on pakollinen": "Alkuaika on pakollinen",
  "Tarkista päättymisaika": "Tarkista päättymisaika",
  "Tarkista ilmoittautumisen päättymisaika": "Tarkista ilmoittautumisen päättymisaika",
  "Otsikko tai teksti puuttuu": "Otsikko tai teksti puuttuu",
  "Uusi tapahtuma": "Uusi tapahtuma",
  "Aika": "Aika",
  "Ryhmä": "Ryhmä",
  "Kysymykset & vastaukset": "Kysymykset & vastaukset",
  "Kysymys": "Kysymys",
  "Uusi kysymys": "Uusi kysymys",
  "Saapunut": "Saapunut",
  "päivää sitten": "päivää sitten",
  "Käsittelyssä": "Käsittelyssä",
  "Otettu käsittelyyn": "Otettu käsittelyyn",
  "Valmis": "Valmis",
  "Palaute": "Palaute",
  "Käyttäjä toivoo vastausta": "Käyttäjä toivoo vastausta",
  "Käyttäjä ei toivo vastausta": "Käyttäjä ei toivo vastausta",
  "Käsittely": "Käsittely",
  "Ota käsittelyyn": "Ota käsittelyyn",
  "Sisäinen lisätieto": "Sisäinen lisätieto",
  "Sisäinen lisätieto ei näy palautteen lähettäjälle": "Sisäinen lisätieto ei näy palautteen lähettäjälle",
  "Kuittaa käsitellyksi": "Kuittaa käsitellyksi",
  "Palautekanava": "Palautekanava",
  "SUODATA": "SUODATA",
  "Saapuneet": "Saapuneet",
  "Käsittely kesken": "Käsittely kesken",
  "Valmiit": "Valmiit",
  "Saapunut tänään": "Saapunut tänään",
  "Lisää kuva klikkaamalla tai raahaamalla kuva tähän": "Lisää kuva klikkaamalla tai raahaamalla kuva tähän",
  "Julkaisuaika": "Julkaisuaika",
  "Liitteet": "Liitteet",
  "Lisää uusi liitetiedosto": "Lisää uusi liitetiedosto",
  "Voit lisätä sivulle liitteitä tallennuksen jälkeen": "Voit lisätä sivulle liitteitä tallennuksen jälkeen",
  "Video": "Video",
  "Lisää uutiseen video": "Lisää uutiseen video",
  "Kysely": "Kysely",
  "Lisää julkaisuun kysymys": "Lisää julkaisuun kysymys",
  "Kyselyyn on vastattu eikä kysymyksiä voi enää muokata": "Kyselyyn on vastattu eikä kysymyksiä voi enää muokata",
  "Kysymykset": "Kysymykset",
  "Uusi monivalintakysymys": "Uusi monivalintakysymys",
  "Uusi avoin kysymys": "Uusi avoin kysymys",
  "Kirjoita kysymys": "Kirjoita kysymys",
  "Lisää vastausvaihtoehto": "Lisää vastausvaihtoehto",
  "Kirjoita vastausvaihtoehto": "Kirjoita vastausvaihtoehto",
  "Uutinen julkaistaan julkaisaikana": "Uutinen julkaistaan julkaisaikana",
  "Uutinen tallennetaan luonnoksena": "Uutinen tallennetaan luonnoksena",
  "Uutiset": "Uutiset",
  "Uusi uutinen": "Uusi uutinen",
  "Näytä vastaukset": "Näytä vastaukset",
  "Julkaisupäivä": "Julkaisupvm",
  "Meidän yritys": "Meidän yritys",
  "Valitse kuva": "Valitse kuva",
  "Lisää sivulle video": "Lisää sivulle video",
  "Vimeo videon id": "Vimeo videon id",
  "Sivu julkaistaan heti": "Sivu julkaistaan heti",
  "Sivu tallennetaan luonnoksena": "Sivu tallennetaan luonnoksena",
  "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomuotoja ovat jpeg sekä png.": "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomuotoja ovat jpeg sekä png.",
  "Uusi sivu": "Uusi sivu",
  "Lisää alasivu": "Lisää alasivu",
  "Yhteenveto": "Yhteenveto",
  "Vastaukset": "Vastaukset",
  "Vastausaika": "Vastausaika",
  "Otsikko ja kuvaus on pakollinen": "Otsikko ja kuvaus on pakollinen",
  "Päivämäärä on pakollinen": "Päivämäärä on pakollinen",
  "Kyselyssä ei ole yhtään kysymystä": "Kyselyssä ei ole yhtään kysymystä",
  "Tarkista kysymykset": "Tarkista kysymykset",
  "Otsikko tai kuvaus puuttuu": "Otsikko tai kuvaus puuttuu",
  "Haluatko varmasti poistaaa kyselyn ja kaikki sen vastaukset?": "Haluatko varmasti poistaaa kyselyn ja kaikki sen vastaukset?",
  "Uusi kysely": "Uusi kysely",
  "Tiedosto": "Tiedosto",
  "Linkki": "Linkki",
  "Valitse uusi tiedosto": "Valitse uusi tiedosto",
  "Tämä tieto on pakollinen": "Tämä tieto on pakollinen",
  "Max 500 merkkiä": "Max 500 merkkiä",
  "Tiedosto julkaistaan heti": "Tiedosto julkaistaan heti",
  "Tiedosto tallennetaan luonnoksena": "Tiedosto tallennetaan luonnoksena",
  "Tiedosto puuttuu": "Tiedosto puuttuu",
  "Linkki puuttuu": "Linkki puuttuu",
  "Tiedostot": "Tiedostot",
  "Uusi tiedosto": "Uusi tiedosto",
  "Avaa": "Avaa",
  "Tyyppi": "Tyyppi",
  "Miten palautteet käsitellään": "Miten palautteet käsitellään",
  "Asetukset": "Asetukset",
  "Palautteiden käsittelykäytäntö": "Palautteiden käsittelykäytäntö",
  "Käyttäjät": "Käyttäjät",
  "Etunimi": "Etunimi",
  "Sukunimi": "Sukunimi",
  "Puhelin": "Puhelin",
  "Sähköposti": "Sähköposti",
  "Työtehtävä": "Työtehtävä",
  "Näytä sähköposti kaikille": "Näytä sähköposti kaikille",
  "Näytä puhelinnumero kaikille": "Näytä puhelinnumero kaikille",
  "Ryhmät": "Ryhmät",
  "Käyttäjä on yrityksen pääkäyttäjä, jolla on oikeudet julkaista kaikkiin ryhmiin": "Käyttäjä on yrityksen pääkäyttäjä, jolla on oikeudet julkaista kaikkiin ryhmiin",
  "Ryhmän ylläpitäjä": "Ryhmän ylläpitäjä",
  "Suodata": "Suodata",
  "Uusi käyttäjä": "Uusi käyttäjä",
  "Näytä ryhmän ylläpitäjät": "Näytä ryhmän ylläpitäjät",
  "Sähköposti": "Sähköposti",
  "Kaikki käyttäjät": "Kaikki käyttäjät",
  "Yrityksen pääkäyttäjät": "Yrityksen pääkäyttäjät",
  "Näytä kuponki": "Näytä kuponki",
  "Sulje": "Sulje",
  "Kirjoita viestisi": "Kirjoita viestisi",
  "Aloita keskustelu": "Aloita keskustelu",
  "Yksityiset keskustelut": "Yksityiset keskustelut",
  "Ei kanavia": "Ei kanavia",
  "Ryhmäkeskustelut": "Ryhmäkeskustelut",
  "Keskustelut": "Keskustelut",
  "Viesti poistettu": "Viesti poistettu",
  "Poista viesti": "Poista viesti",
  "Olet ilmoittautunut tapahtumaan": "Olet ilmoittautunut tapahtumaan",
  "Peru ilmoittautuminen": "Peru ilmoittautuminen",
  "Et ole ilmoittautunut tapahtumaan": "Et ole ilmoittautunut tapahtumaan",
  "Ilmoittaudu mukaan": "Ilmoittaudu mukaan",
  "Jätä palaute tai kysymys": "Jätä palaute tai kysymys",
  "Kiitos, viesti lähetetty": "Kiitos, viesti lähetetty",
  "Kirjoita palaute tai kysymys": "Kirjoita palaute tai kysymys",
  "Haluan henkilökohtaisen vastauksen": "Haluan henkilökohtaisen vastauksen",
  "Anna sähköposti tai puhelinnumero": "Anna sähköposti tai puhelinnumero",
  "Miten palautteet käsitellään?": "Miten palautteet käsitellään?",
  "Anna sähköpostiosoite tai puhelinnumero": "Anna sähköpostiosoite tai puhelinnumero",
  "Tervetuloa Piiriin": "Tervetuloa Piiriin",
  "Käyttäjätunnus tai puhelinnumero": "Käyttäjätunnus tai puhelinnumero",
  "Jatka": "Jatka",
  "Salasana": "Salasana",
  "Kirjaudu sisään": "Kirjaudu sisään",
  "Pin koodi": "Pin koodi",
  "Pin koodin saapumisessa voi kestää hetken.": "Pin koodin saapumisessa voi kestää hetken.",
  "Kirjautuminen epäonnistui": "Kirjautuminen epäonnistui",
  "Kirjautuminen epäonnistui, tarkista pin koodi": "Kirjautuminen epäonnistui, tarkista pin koodi",
  "Kirjaudutaan ulos...": "Kirjaudutaan ulos...",
  "Uusimmat": "Uusimmat",
  "Meillä töissä": "Meillä töissä",
  "Piiri-artikkelit": "Piiri-artikkelit",
  "Omat tiedot & asetukset": "Omat tiedot ja asetukset",
  "Tietoa Piiri-sovelluksesta": "Tietoa Piiri-sovelluksesta",
  "Mikä on Piiri Kit?": "Mikä on Piiri Kit?",
  "Tietosuojaseloste": "Tietosuojaseloste",
  "Töissä": "Töissä",
  "Poissa töistä": "Poissa töistä",
  "Anna avainsana kaikilla kielillä.": "Anna avainsana kaikilla kielillä.",
  "Avainsana": "Avainsana",
  "Haluatko varmasti poistaa avainsanan?": "Haluatko varmasti poistaa avainsanan?",
  "Muokkaa avainsanaa": "Muokkaa avainsanaa",
  "Luo uusi avainsana": "Luo uusi avainsana",
  "Avainsanat": "Avainsanat",
  "Hae avainsanoja tai lisää uusi": "Hae avainsanoja tai lisää uusi",
  "Paina Enter luodaksesi uuden avainsanan": "Paina Enter luodaksesi uuden avainsanan",
  "Avainsanojen hallinta": "Avainsanojen hallinta",
  "Uudistamme kyselyjä. Pääset kokeilemaan uutta kyselytyökalua": "Uudistamme kyselyjä. Pääset kokeilemaan uutta kyselytyökalua",
  "tästä": "tästä",
  "Kyselyn vastaukset": "Kyselyn vastaukset",
  "Viimeisin vastaus": "Viimeisin vastaus",
  "Näytetään": "Näytetään",
  "Kyselyä ei löytynyt": "Kyselyä ei löytynyt",
  "Saat PIN-koodin tekstiviestillä mikäli puhelinnumerosi on järjestelmässämme. Syötä se alle.": "Saat PIN-koodin tekstiviestillä mikäli puhelinnumerosi on järjestelmässämme. Syötä se alle.",
  "Jos et saanut PIN-koodia, tarkista että syötit puhelinnumerosi oikein.": "Jos et saanut PIN-koodia, tarkista että syötit puhelinnumerosi oikein.",
  "Kirjoita hakusana": "Kirjoita hakusana",
  "Hakusanan tulee olla vähintään 3 merkkiä pitkä": "Hakusanan tulee olla vähintään 3 merkkiä pitkä"
}
